import { Reveal, SectionHead } from './Reveal';
import { Zap, Landmark, Gavel, ArrowUpRight } from 'lucide-react';
import { WA_DEFAULT_LINK } from '../lib/lead';

const SERVICES = [
  {
    icon: Zap,
    img: 'https://images.unsplash.com/photo-1632040804304-4094a1a63be7?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200',
    title: 'Virtual Court Resolution',
    desc: 'Rapid online settlement for speeding, signal-jump, and red-light camera e-challans — often settled within days.',
    tags: ['Speeding', 'Signal Jump', 'Camera E-Challans'],
  },
  {
    icon: Landmark,
    img: 'https://images.unsplash.com/photo-1589391886645-d51941baf7fb?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200',
    title: 'Lok Adalat Fine Reduction',
    desc: 'Maximum legal fine waivers through official state Lok Adalat bench representation. Pay only what the court rules.',
    tags: ['Fine Reduction', 'One-Time Settlement', 'Old Challans'],
  },
  {
    icon: Gavel,
    img: 'https://images.pexels.com/photos/15555559/pexels-photo-15555559.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    title: 'Court Summons & Impound Defense',
    desc: 'Immediate legal representation for serious traffic court summons and vehicle impound release orders.',
    tags: ['Summons Reply', 'Impound Release', 'Hearing Representation'],
  },
];

export default function Services() {
  return (
    <section id="services" className="py-20 lg:py-28 bg-[#F8FAFC]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHead
            eyebrow="Services — Virtual Court / Lok Adalat"
            title="Specialized Traffic Legal Services"
            sub="One legal desk for every kind of challan — from a camera ticket to a court summons."
          />
          <Reveal delay={0.2}>
            <a
              href={WA_DEFAULT_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden lg:inline-flex items-center gap-2 rounded-xl border-2 border-brand-blue text-brand-blue hover:bg-brand-blue hover:text-white font-bold text-sm px-6 py-3 transition-all"
              data-testid="services-whatsapp-link"
            >
              Start on WhatsApp <ArrowUpRight size={16} strokeWidth={2.5} />
            </a>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {SERVICES.map(({ icon: Icon, img, title, desc, tags }, i) => (
            <Reveal key={title} delay={i * 0.12}>
              <article
                className="group h-full flex flex-col rounded-2xl bg-white border border-slate-200 overflow-hidden transition-all duration-300 hover:-translate-y-1.5 hover:shadow-2xl hover:shadow-brand-blue/10"
                data-testid={`service-card-${i + 1}`}
              >
                <div className="spotlight-frame h-44 shrink-0">
                  <img src={img} alt={title} loading="lazy" className="w-full h-full object-cover" />
                  <span className="absolute top-4 left-4 z-10 inline-flex items-center gap-1.5 rounded-lg bg-white/90 backdrop-blur px-3 py-1.5 text-[11px] font-bold uppercase tracking-wider text-brand-blue">
                    <Icon size={13} strokeWidth={2.5} className="text-brand-orange" />
                    Service {i + 1}
                  </span>
                </div>
                <div className="flex flex-col grow p-7">
                  <h3 className="font-display text-2xl font-bold text-brand-ink">{title}</h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-slate-500 grow">{desc}</p>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {tags.map((t) => (
                      <span key={t} className="rounded-full bg-slate-100 border border-slate-200 px-3 py-1 text-[11px] font-bold text-slate-600">
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
